function log(...args: any[]) {
  window.sttDebug && console.log(...args);
}
function warn(...args: any[]) {
  window.sttDebug && console.warn(...args);
}
function error(...args: any[]) {
  window.sttDebug && console.error(...args);
}
export { log, warn, error };